export default __webpack_public_path__ + "static/media/front_page_3.b2c48a2b.jpg";